module.exports = __webpack_public_path__ + "static/media/slick.ced611da.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/slick.eot?#iefix
// module id = 339
// module chunks = 0